import { Box } from '@mantine/core';
import { LoadingAnimation } from '../chat/components/LoadingAnimation';
import { TurnState } from './types';

export function ConversationStatusBadge({ turnState }: { turnState: TurnState }) {
  if (turnState === 'FAILED') {
    return (
      <Box
        w={8}
        h={8}
        bg="gray.5"
        style={{ borderRadius: '50%' }}
        aria-label="Response didn't finish"
      />
    );
  }

  if (turnState === 'UNREAD') {
    return <Box w={8} h={8} bg="orange.6" style={{ borderRadius: '50%' }} aria-label="Unread" />;
  }

  if (turnState === 'PROCESSING') {
    return <LoadingAnimation />;
  }

  return null;
}
